(function (module) {
  'use strict';
  module.controller('PhoneNotificationController', ['$rootScope', '$scope', '$state', '$http', 'socket',
    'socketTransmit', 'socketLogin', 'alertService', 'authService',
    function ($rootScope, $scope, $state, $http, socket, socketTransmit, socketLogin, alertService, authService) {
      $scope.groupAlerts = [];

      //init of page
      function updateAlerts() {
        alertService.getUnhandledVoiceAlerts().then(function (response) {
          var unhandledVoiceAlerts = response.data;
          console.log('response ', response);
          console.log('unhandledVoiceAlerts ', unhandledVoiceAlerts);

          //25550624/group-by-multiple-values-underscore-js-but-keep-the-keys-and-values
          var groups = _.groupBy(unhandledVoiceAlerts, function (alert) {
            return alert.fromNumber + '#' + alert.firstName + '#' + alert.lastName;
          });

          console.log('groups ', groups);
          
          var groupAlerts = _.map(groups, function (group) {
            return {
              fromNumber: group[0].fromNumber,
              firstName: group[0].member.FirstName,
              lastName: group[0].member.LastName,
              email: group[0].member.Email,
              travelerId: group[0].member.Id,
              organizationName: group[0].member.Organization.Name,
              alerts: _.map(group, function (g) {
                return {                  
                  time: moment(g.time).format('MM-DD-YYYY h:mm:ss'),                  
                };
              }),

              topic: group[0].topic,
            };
          });

          $scope.groupAlerts = groupAlerts;
          console.log($scope.groupAlerts);
        });
      };

      updateAlerts();

      //on socket event
      $scope.$on('updateAlertCountVoice', function (event, data) {        
        updateAlerts();
      });

      //on user's action
      $scope.handleAlert = function (alert) { //fromNumber, firstName, lastName) {
        var loginMember = authService.getLoginMember();
        loginMember['SupportsOrganizations'] = []
        var handleData = {
          fromNumber: alert.fromNumber,
          socketId: socketLogin.getSocketId(),          
          travelAgencyId: loginMember.Organization.Id,
          travelAgencyName: loginMember.Organization.Name,
          travelAgentFirstName: loginMember.FirstName,
          travelAgentLastName: loginMember.LastName,
          travelAgentEmail: loginMember.Email,
          travelAgentId: loginMember.Id,
          topic: alert.topic,
          travelerFirstName: alert.firstName,
          travelerLastName: alert.lastName,
          travelerOrganizationName: alert.organizationName,
        };
        $rootScope.$broadcast('phoneHandle', handleData);
        if ($state.current.name !== 'app.phone') {
          $http.post('/handlePhone', handleData);
          $state.go('app.phone', {
            fromNumber: alert.fromNumber,
            travelerFirstName: alert.firstName,
            travelerLastName: alert.lastName,
            travelerOrganizationName: alert.organizationName,
            travelerId: alert.travelerId,
            topic: alert.topic,
          });
        } else {
          $state.go($state.current, {}, {
            reload: true,
          });
        }
      };
    },
  ]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/phoneNotificationController.js